import React from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { LogoIcon } from 'icons';
import { authSlice } from 'slices';
import { ROOT_ROUTE } from 'constants/routes';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';

export const DealerHeader: React.FC = () => {
  const dispatch = useAppDispatch();
  const { dealer } = useAppSelector((state) => state.auth.data);
  const { t } = useTranslation();

  const logout = () => {
    localStorage.clear();
    dispatch(authSlice.actions.gotoHome({ redirectTo: ROOT_ROUTE }));
  };

  return (
    <Navbar expand="md" className="h-100 user-navbar">
      <div style={{ position: 'absolute' }}>
        <strong className="color-gray">{t('dealerManagement.name')}: </strong>{' '}
        {`${dealer?.name} `}
        <strong className="color-gray">
          {t('dealerManagement.dealerId')}:{' '}
        </strong>
        {`${dealer?.dealerId}`}
      </div>
      <div className="user-navbar-brand">
        <LogoIcon />
      </div>
      <Navbar.Collapse
        className="justify-content-end m-5"
        style={{ width: '200%' }}
      >
        <Nav.Link style={{ color: '#3A3F4B' }} role="button" onClick={logout}>
          <strong>Sign out</strong>
        </Nav.Link>
      </Navbar.Collapse>
    </Navbar>
  );
};
